import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const DeviceInfo = ({deviceData, openModal}) => {

    const isDisabled = deviceData ? (deviceData.meta.usedDeviceSlots === deviceData.meta.maxDeviceSlots || deviceData.devices.length === 1 || !deviceData.devices) : true;

    // Add hover effect for the trash can icon
    const trashIconStyle = {
        cursor: isDisabled ? "not-allowed" : "pointer",
        color: isDisabled ? "#d3d3d3" : "#AEAFBA",
        transition: "color 0.3s ease"
    };

    const trashIconHoverStyle = {
        color: "red"
    };

    return (
        <div className='p-4 mt-3 rounded col-10 col-md-8 col-lg-6 mb-5' style={{border: "1px solid #AEAFBA"}}>
            <div className='d-flex'>
                <h3>Devices <span style={{color: "#AEAFBA"}}>({deviceData ? deviceData.meta.usedDeviceSlots : 0}/{deviceData ? deviceData.meta.maxDeviceSlots : 0})</span></h3>

                {/* button that says status of subscription */}
            </div>
            {!deviceData || deviceData.devices.length === 0 ? (
                <p>No devices found.</p>
            ) : (
                <div>
                    <div className='d-flex justify-content-between align-items-center' style={{cursor: "pointer"}}>
                        <div>
                            <p className='m-0' style={{fontSize: "15px"}}>{deviceData.devices[0].deviceType} Device</p>
                            <p className='m-0' style={{fontWeight: 300}}>{deviceData.devices[0].deviceModel}</p>
                            <p style={{fontSize: "12px", color: "#AEAFBA"}}>last watched: {new Date(deviceData.devices[0].lastWatchedAt).toLocaleString()}</p>
                        </div>
                        <FontAwesomeIcon
                            icon={faTrash}
                            style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                color: isDisabled ? "#d3d3d3" : "#AEAFBA", // Gray out if disabled
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = trashIconHoverStyle.color}
                            onMouseLeave={(e) => e.currentTarget.style.color = trashIconStyle.color}
                            onClick={!isDisabled ? () => openModal('deleteDeviceA') : undefined}
                        />    
                    </div>

                    {deviceData.devices[1] && (
                    <div className='d-flex justify-content-between align-items-center mt-3' style={{cursor: "pointer"}}>
                        <div>
                            <p className='m-0' style={{fontSize: "15px"}}>{deviceData.devices[1].deviceType} Device</p>
                            <p className='m-0' style={{fontWeight: 300}}>{deviceData.devices[1].deviceModel}</p>
                            <p style={{fontSize: "12px", color: "#AEAFBA"}}>last watched: {new Date(deviceData.devices[1].lastWatchedAt).toLocaleString()}</p>

                        </div>
                        <FontAwesomeIcon
                            icon={faTrash}
                            style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                color: isDisabled ? "#d3d3d3" : "#AEAFBA", // Gray out if disabled
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = trashIconHoverStyle.color}
                            onMouseLeave={(e) => e.currentTarget.style.color = trashIconStyle.color}
                            onClick={!isDisabled ? () => openModal('deleteDeviceB') : undefined}
                        />
                    </div>
                    )}

                </div>
            )}
        </div>
    )
}

export default DeviceInfo